
<!-- Sidebar -->
<app-side-bar></app-side-bar>
<div id="page-content-wrapper">
  <router-outlet></router-outlet>
  <div ui-view></div>
</div>
<notifier-container></notifier-container>